import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';

const IFrameGeneralWrapperComponent = (props) => {
  const [url, setUrl] = useState('');
  const externalURL = props.iContent.generalUrl.value;

  useEffect(() => {
    let currentParams = getCurrentParamsURL();
    let statusHeader = returnStatusHeader();
    if (props.iContent.generalUrl.value !== null) {
      if (currentParams !== null || currentParams !== '') {
        setUrl(externalURL + '/?' + currentParams + '&' + 'hideSiteHeader=' + statusHeader);
      } else {
        setUrl(externalURL + '/?' + 'hideSiteHeader=' + statusHeader);
      }
    }
  }, []);

  const getCurrentParamsURL = () => {
    let pageURL = document.location.href.split('?');
    if (pageURL.length > 1) {
      let currentParams = document.location.href.split('?')[1];
      return currentParams;
    } else {
      return '';
    }
  };

  const returnStatusHeader = () => {
    let items = props.iContentRepo;
    let currentPath = props.currentPath;
    const last = currentPath.charAt(currentPath.length - 1);
    if (last != '/') {
      currentPath += '/';
    }
    const res = Object.values(items).find((item) => item.path == currentPath);
    let isHideHeaderSiteHeader = res.content.hideSiteHeader?.value ? true : false;
    return isHideHeaderSiteHeader;
  };

  return (
    <div className={`${isMobile ? 'pl-0 pr-0' : ''} iframe-general-wrapper `}>
      <iframe
        className={`scrolling ${isMobile ? 'mobile' : ''} iframe-general `}
        src={url}
        title='I frame general'
        frameBorder='0'
        scrolling='auto'
        width='100%'
        height='100%'></iframe>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
    iContentRepo: state.iContentRepo.items,
    currentPath: state.ViewContext.currentPath,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(IFrameGeneralWrapperComponent);
